import { Component, input, output } from '@angular/core';
import { User } from '../../../types/user.model';
import { UserAvatarV2Component } from '../../user-avatar-v2/user-avatar-v2.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-my-forest-list-special',
  imports: [UserAvatarV2Component, TranslatePipe],
  templateUrl: './my-forest-list-special.component.html',
  styleUrl: './my-forest-list-special.component.scss'
})
export class MyForestListSpecialComponent {
  list = input<User[]>();

  userClick = output<User>();

  onMemberClick(user: User): void {
    this.userClick.emit(user);
  }
}
